import { useEffect } from "react";
import Lenis from "lenis";
import Navbar from "@/components/landing/Navbar";
import Hero from "@/components/landing/Hero";
import Marquee from "@/components/landing/Marquee";
import HowItWorks from "@/components/landing/HowItWorks";
import Comparison from "@/components/landing/Comparison";
import Categories from "@/components/landing/Categories";
import About from "@/components/landing/About";
import VideoSection from "@/components/landing/VideoSection";
import Testimonials from "@/components/landing/Testimonials";
import FAQ from "@/components/landing/FAQ";
import FinalCTA from "@/components/landing/FinalCTA";
import Footer from "@/components/landing/Footer";
import PrivacyModal from "@/components/landing/PrivacyModal";
import WhatsAppFloat from "@/components/landing/WhatsAppFloat";
import ChatWidget from "@/components/chat/ChatWidget";

export default function Landing() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.11, smoothWheel: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="min-h-screen bg-white text-slate-900">
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <HowItWorks />
        <Comparison />
        <Categories />
        <About />
        <VideoSection />
        <Testimonials />
        <FAQ />
        <FinalCTA />
      </main>
      <Footer />
      <PrivacyModal />
      <WhatsAppFloat />
      <ChatWidget />
    </div>
  );
}
